<template>
  <!-- Canvas-only control cluster: zoom, fit, auto-layout, flow direction.
       Positioning is the parent's job (BuilderToolbar places it top-right of the
       editor canvas; RunCanvas places its own copy) — this just renders the
       button column. View-mode toggle, expand/collapse, and Run all live at the
       surface level, not here, because a run canvas has none of them. -->
  <div class="canvas-controls d-flex flex-column gap-1">
    <button
      type="button"
      class="btn bb-btn-vueflow-ctrl d-flex align-items-center justify-content-center"
      title="Zoom In"
      @click="$emit('zoomIn')"
    >
      <i class="bi bi-plus"></i>
    </button>
    <button
      type="button"
      class="btn bb-btn-vueflow-ctrl d-flex align-items-center justify-content-center"
      title="Zoom Out"
      @click="$emit('zoomOut')"
    >
      <i class="bi bi-dash"></i>
    </button>
    <button
      type="button"
      class="btn bb-btn-vueflow-ctrl d-flex align-items-center justify-content-center"
      title="Fit to View"
      @click="$emit('fitView')"
    >
      <i class="bi bi-arrows-fullscreen"></i>
    </button>
    <button
      type="button"
      class="btn bb-btn-vueflow-ctrl d-flex align-items-center justify-content-center"
      title="Auto Layout"
      @click="$emit('applyHierarchicalLayout')"
    >
      <i class="bi bi-diagram-3"></i>
    </button>
    <button
      type="button"
      class="btn bb-btn-vueflow-ctrl d-flex align-items-center justify-content-center"
      :title="`Toggle Flow Direction (Currently: ${flowDirection === 'TB' ? 'Top-Bottom' : 'Left-Right'})`"
      @click="$emit('toggleFlowDirection')"
    >
      <i :class="flowDirection === 'TB' ? 'bi bi-arrow-down-up' : 'bi bi-arrow-left-right'"></i>
    </button>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  flowDirection: string;
}>();

defineEmits<{
  zoomIn: [];
  zoomOut: [];
  fitView: [];
  applyHierarchicalLayout: [];
  toggleFlowDirection: [];
}>();
</script>
